import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import ContentPagesPage, { contentPagesLoader } from "./Pages";
import PageEditorPage, { pageEditorLoader } from "./PageEditor";

/** Content → Pages — the text pages customers read — spread into the root route's children in main.tsx. */
export const contentRoutes: RouteObject[] = [
  { path: "content/pages", Component: ContentPagesPage, loader: contentPagesLoader, errorElement: <AppError /> },
  { path: "content/pages/new", Component: PageEditorPage, loader: pageEditorLoader, errorElement: <AppError /> },
  { path: "content/pages/:slug", Component: PageEditorPage, loader: pageEditorLoader, errorElement: <AppError /> },
];
